import type { Session } from 'src/shared/session';

import { isGuest } from './isGuest';

export function isSessionStaff(session: Session) {
	return !isGuest(session) && !!session.user && !!session.user.roles && !!session.user.roles.staff;
}
